import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { AlertCircle } from 'lucide-react-native'
import { colors } from '@chillout/core'
import { Button, InlineAlert } from '@chillout/ui'

interface PairingCodeExpiredCardProps {
  loading: boolean
  isError: boolean
  onRegenerate: () => void
}

export function PairingCodeExpiredCard({ loading, isError, onRegenerate }: PairingCodeExpiredCardProps) {
  const { t } = useTranslation()
  return (
    <View className="gap-3 rounded-lg border border-border bg-canvas-primary p-4">
      <View className="flex-row items-center gap-2">
        <AlertCircle size={16} color={colors.warning} strokeWidth={2} />
        <Text className="text-sm font-semibold text-primary">{t('operations.editDevice.pairingCodeExpiredPrefix')}</Text>
      </View>
      <Text className="text-sm font-normal text-secondary">
        {t('operations.editDevice.pairingCodeExpiredDescription')}
      </Text>
      <Button
        label={t('operations.editDevice.generateNewCodeButton')}
        loadingLabel={t('operations.editDevice.generatingNewCodeButton')}
        variant="secondary"
        className="bg-canvas-card"
        loading={loading}
        onPress={onRegenerate}
      />
      {isError && <InlineAlert message={t('operations.editDevice.regenerateCodeError')} />}
    </View>
  )
}
